import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add\"><g class=\"is-icon-target\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m0 0v14\" transform=\"translate(12 5)\" /><path d=\"m0 0h14\" transform=\"translate(5 12)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol